import React from "react";
import { IndexTable, Link, Text } from "@shopify/polaris";

import { format } from "date-fns";

import { useFormatCurrency } from "hooks/use-format-currency";

export const UtmSetOrdersTableRow = ({ data, index }) => {
  const {
    name,
    order_created_at,
    shop_money_order_amount,
    shop_money_currency_code,
    order_id,
    customer_name,
    customer_shopify_id,
  } = data;
  const formatCurrency = useFormatCurrency();

  const handleCustomerClick = () => {
    const customerId = customer_shopify_id.split("Customer/")[1];
    open(`shopify://admin/customers/${customerId}`, '_top');
  };

  let customerToRender = "-";
  if (customer_name) {
    customerToRender = (
      <Link removeUnderline onClick={handleCustomerClick}>
        {customer_name}
      </Link>
    );
  }

  const formattedAmount = formatCurrency(shop_money_order_amount, {
    currency: shop_money_currency_code,
  });

  return (
    <IndexTable.Row id={order_id} key={order_id} position={index}>
      <IndexTable.Cell>
        <Link
          removeUnderline
          onClick={() => {
            const orderId = order_id.split("Order/")[1];
            open(`shopify://admin/orders/${orderId}`, '_top');
          }}
        >
          <Text variant="bodyMd" as="span">{name}</Text>
        </Link>
      </IndexTable.Cell>
      <IndexTable.Cell>
        {customerToRender}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" as="span">
          {format(new Date(order_created_at), "MMM do 'at' h':'mmaaa")}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" as="span" fontWeight="semibold" alignment="end" numeric>
          {formattedAmount}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};
